<div class="content">
  <div class="fila1">
    <table>
      <tr>
        <td class="col1">
          <h1 class="title-dialog">{{ 'datosgenerales' | translate }}</h1>
        </td>
        <td class="col6">
          <mat-icon color="warn" matTooltip="{{ 'cerrar' | translate }}" (click)="onNoClick()" matTooltipClass="colortooltip">
            close
          </mat-icon>
        </td>
      </tr>
    </table>
  </div>

  <div mat-dialog-content>
    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'nombre' | translate }}</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Nombre" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'provincia' | translate }}</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Provincia" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'codigoPostal' | translate }}</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.CodPostal" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'poblacion' | translate }}</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Poblacion" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'contacto' | translate }}</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Contacto" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'telefono' | translate }}</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Telefono" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'contacto' | translate }} 2</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Contacto2" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'telefono' | translate }} 2</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Telefono2" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'correo' | translate }}</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Email" [disabled]="modificar" />
    </mat-form-field>

    <!-- <mat-form-field class="mat">
    <mat-label>{{'tazas' | translate}}</mat-label>
    <input matInput class="inputNuevo" [(ngModel)]="data.CUPS" [disabled]='modificar'>
  </mat-form-field> -->

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'idtarifaconf' | translate }}</mat-label>
      <input matInput type="text" class="inputNuevo" [(ngModel)]="data.IdTarifa" [disabled]="modificar" [readonly]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'Latitud' | translate }}</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Latitud" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'Longitud' | translate }}</mat-label>
      <input matInput class="inputNuevo" [(ngModel)]="data.Longitud" [disabled]="modificar" />
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'fechaInstalacion' | translate }}</mat-label>
      <input matInput [matDatepicker]="picker" (click)="picker.open()" [formControl]="date" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="mat" appearance="outline">
      <mat-label>{{ 'fechaInstalacionAcometida' | translate }}</mat-label>
      <input matInput [matDatepicker]="pickerA" (click)="pickerA.open()" [formControl]="date2" />
      <mat-datepicker-toggle matSuffix [for]="pickerA"></mat-datepicker-toggle>
      <mat-datepicker #pickerA></mat-datepicker>
    </mat-form-field>

    <mat-slide-toggle color="primary" class="slideAdministrar" [disabled]="modificar" [(ngModel)]="data.Eliminado">{{
      'activo' | translate
    }}</mat-slide-toggle>

    @if (rol === 1 || rol === 9) {
      <div class="tablaMunicipios">
        <h5 class="titulotabla">{{ 'usuariosAsignados' | translate }}</h5>
        <table mat-table #mitabla [dataSource]="dataUser" matSort>
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="titulotabla">
              <div id="text">{{ 'nombre' | translate }}</div>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
          </ng-container>
          <ng-container matColumnDef="rol">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="titulotabla">
              <div id="text">{{ 'rol' | translate }}</div>
            </th>
            <td mat-cell *matCellDef="let element">{{ element.rol }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedCol"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedCol"></tr>
        </table>
        <mat-paginator #paginador [pageSize]="5" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
    }
  </div>
</div>
